import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'

// PrimeVue components
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import ProgressBar from 'primevue/progressbar'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
import RadioButton from 'primevue/radiobutton'
import Rating from 'primevue/rating'
import Chart from 'primevue/chart'
import Menu from 'primevue/menu'
import Menubar from 'primevue/menubar'
import Sidebar from 'primevue/sidebar'
import Toolbar from 'primevue/toolbar'
import Panel from 'primevue/panel'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Message from 'primevue/message'
import InlineMessage from 'primevue/inlinemessage'
import ProgressSpinner from 'primevue/progressspinner'
import Tag from 'primevue/tag'
import InputNumber from 'primevue/inputnumber'
import MultiSelect from 'primevue/multiselect'
import OverlayPanel from 'primevue/overlaypanel'

// Styles
import 'primevue/resources/themes/lara-light-green/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import './assets/styles/theme-base.css'
import './assets/styles/primevue-themes.css'
import './assets/styles/main.css'
import './assets/styles/dark-theme.css'

const app = createApp(App)

// Use plugins
app.use(store)
app.use(router)
app.use(PrimeVue, { ripple: true })
app.use(ToastService)
app.use(ConfirmationService)

// Register PrimeVue components
app.component('Button', Button)
app.component('InputText', InputText)
app.component('Password', Password)
app.component('Card', Card)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Dialog', Dialog)
app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)
app.component('ProgressBar', ProgressBar)
app.component('Dropdown', Dropdown)
app.component('Calendar', Calendar)
app.component('Textarea', Textarea)
app.component('Checkbox', Checkbox)
app.component('RadioButton', RadioButton)
app.component('Rating', Rating)
app.component('Chart', Chart)
app.component('Menu', Menu)
app.component('Menubar', Menubar)
app.component('Sidebar', Sidebar)
app.component('Toolbar', Toolbar)
app.component('Panel', Panel)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('Message', Message)
app.component('InlineMessage', InlineMessage)
app.component('ProgressSpinner', ProgressSpinner)
app.component('Tag', Tag)
app.component('InputNumber', InputNumber)
app.component('MultiSelect', MultiSelect)
app.component('OverlayPanel', OverlayPanel)

app.mount('#app') 